import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { times } from 'lodash/fp';
import { OccupancyData } from './occupancyTypes';

interface DistributeRoomsWithAgeCategoriesOptions {
    maxPersonCount: number;
    maxRoomCount: number;
    datesOccupancy: OccupancyData[];
}

export const distributeRooms = ({
    maxPersonCount,
    maxRoomCount,
    datesOccupancy,
}: DistributeRoomsWithAgeCategoriesOptions) => {
    let rooms: OccupancyData[][] = [];

    // Used for partially full or mixed rooms
    let remainingRoom: OccupancyData[] = [];
    let remainingRoomPersonCount = 0;

    for (const datesOccupancyItem of datesOccupancy) {
        const fullRoomsCount = Math.floor(datesOccupancyItem.personCount / maxPersonCount);
        const remainingPersonCount = datesOccupancyItem.personCount % maxPersonCount;

        // Overflow resulting in partially full or mixed rooms
        if (remainingRoomPersonCount + remainingPersonCount > maxPersonCount) {
            remainingRoom.push({
                ageCategoryId: datesOccupancyItem.ageCategoryId,
                personCount: maxPersonCount - remainingRoomPersonCount,
            });

            rooms.push(remainingRoom);

            remainingRoomPersonCount = (remainingRoomPersonCount + remainingPersonCount) % maxPersonCount;
            remainingRoom = [
                {
                    ageCategoryId: datesOccupancyItem.ageCategoryId,
                    personCount: remainingRoomPersonCount,
                },
            ];
        } else if (remainingPersonCount > 0) {
            remainingRoom.push({ ageCategoryId: datesOccupancyItem.ageCategoryId, personCount: remainingPersonCount });
            remainingRoomPersonCount += remainingPersonCount;
        }

        // Full rooms
        rooms = [
            ...rooms,
            ...times(
                () => [{ ageCategoryId: datesOccupancyItem.ageCategoryId, personCount: maxPersonCount }],
                fullRoomsCount
            ),
        ];
    }

    if (remainingRoom.length > 0) {
        rooms.push(remainingRoom);
    }

    // Add categoryIndex (aka roomIndex)
    return pipe(
        rooms.slice(0, maxRoomCount),
        array.mapWithIndex((categoryIndex, room) =>
            pipe(
                room,
                array.map((roomAgeCategory) => ({ categoryIndex, ...roomAgeCategory }))
            )
        ),
        array.flatten
    );
};
